import { render, staticRenderFns } from "./screening-check-result-dialog.vue?vue&type=template&id=1e074f86&scoped=true"
import script from "./screening-check-result-dialog.vue?vue&type=script&lang=js"
export * from "./screening-check-result-dialog.vue?vue&type=script&lang=js"
import style0 from "./screening-check-result-dialog.vue?vue&type=style&index=0&id=1e074f86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e074f86",
  null
  
)

export default component.exports